import root from './_root';

/** Built-in value references. */
var Symbol = root.Symbol;

export default Symbol;
